import gql from 'graphql-tag'

export const GIVING_ENABLED_QUERY = gql`
  query brandConfig {
    brandConfig {
      givingEnabled
    }
  }
`
